exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.project-toggler .dropdown-menu {\n\tmargin: 0;\n\tpadding: 0;\n}\n.project-toggler .label-only {\n\tcolor: #007949;\n\tfont-weight: bold;\n\tdisplay: inline-block;\n\tbackground-color: #eee;\n\tborder: 1px solid #eee;\n\tpadding: 0.25rem 0.5rem;\n\tfont-size: 0.875rem;\n\tline-height: 1.5;\n\tborder-radius: 0.2rem;\n}\n", ""]);

// exports
